import React, { useState, useEffect } from "react";
import axios from "axios";
import CircularProgress from '@mui/material/CircularProgress';

function EKYC_Failed_Report() {
  const months = [
    { month: 1, name: "January" },
    { month: 2, name: "February" },
    { month: 3, name: "March" },
    { month: 4, name: "April" },
    { month: 5, name: "May" },
    { month: 6, name: "June" },
    { month: 7, name: "July" },
    { month: 8, name: "August" },
    { month: 9, name: "September" },
    { month: 10, name: "October" },
    { month: 11, name: "November" },
    { month: 12, name: "December" }
  ];

  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 2019; i <= currentYear; i++) {
      years.push(i.toString());
    }
    return years;
  };

  const years = generateYears();
  
  const [districts, setDistricts] = useState([]);
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [district, setDistrict] = useState("");
  const [exists, setExists] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initLoading, setInitLoading] = useState(true);

  useEffect(() => {
    setInitLoading(true);
    
    axios.get(`${process.env.REACT_APP_URL}/api/ekycfailed/currentMonthYear`)
      .then((res) => {
        if (res.data) {
          const currentMonth = res.data.month?.toString() || "";
          const currentYear = res.data.year?.toString() || "";
          
          setMonth(currentMonth);
          setYear(currentYear);
        }
        
        return axios.get(`${process.env.REACT_APP_URL}/api/ekycfailed/districts`);
      })
      .then((res) => {
        setDistricts(res.data || []);
        setInitLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setInitLoading(false);
      });
  }, []);

  const handleSubmit = () => {
    setLoading(true);
    if (!month || !year || !district) {
      alert("Please select Month, Year, and District.");
      setLoading(false);
      return;
    }
    
    axios
      .get(`${process.env.REACT_APP_URL}/api/ekycfailed/exists`, {
        params: { month, year, distName: district },
      })
      .then((res) => setExists(res.data))
      .finally(() => setLoading(false));
  };

  const handleDownload = () => {
    axios
      .get(`${process.env.REACT_APP_URL}/api/ekycfailed/download`, {
        params: { month, year, distName: district },
      })
      .then((res) => {
        if (!res.data || res.data.length === 0) {
          alert("No data available for download");
          return;
        }
        setData(res.data);

        const title = `EKYC Failed Data for District: ${district}, Month: ${month}, Year: ${year}`;
        const headingRow = `
          <tr>
            <td colspan="8" style="font-weight:bold; color:black; text-align:center;">${title}</td>
          </tr>
        `;
        const headerRow = `
          <tr colspan="8" style="font-weight:bold; text-align:center;  color:black;">
            <td>District</td>
            <td>Block</td>
            <td>FPS ID</td>
            <td>RC ID</td>
            <td>UID (Masked)</td>
            <td>eKYC Status</td>
            <td>Error Code</td>
            <td>Error Description</td>
          </tr>
        `;
        const bodyRows = res.data
          .map(
            (r) => `
            <tr>
              <td>${r.district}</td>
              <td>${r.block}</td>
              <td style="mso-number-format:'\\@';">${r.fpsId}</td>
              <td style="mso-number-format:'\\@';">${r.rcId}</td>
              <td style="mso-number-format:'\\@';">${r.uid}</td>
              <td>${r.ekycType}</td>
              <td>${r.errorCode}</td>
              <td>${r.errorDesc}</td>
            </tr>
          `
          )
          .join("");

        const blob = new Blob(
          [`<table border="1">${headingRow}${headerRow}${bodyRows}</table>`],
          { type: "application/vnd.ms-excel" }
        );

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `EKYC_Failed_Data_${district}_${month}_${year}.xls`;
        a.click();
      });
  };

  if (initLoading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div style={{ textAlign: "center" }}>
      <table border="1" align="center" style={{ marginTop: "15px" }}>
        <tbody>
          <tr className="tableheader">
            <td colSpan="6">EKYC Failed Details</td>
          </tr>
          <tr>
            <td>Month</td>
            <td>
              <select value={month} onChange={(e) => setMonth(e.target.value)}>
                <option value="">--Select--</option>
                {months.map((m, i) => (
                  <option key={i} value={m.month}>
                    {m.name}
                  </option>
                ))}
              </select>
            </td>
            <td>Year</td>
            <td>
              <select value={year} onChange={(e) => setYear(e.target.value)}>
                <option value="">--Select--</option>
                {years.map((y, i) => (
                  <option key={i} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </td>
            <td>District</td>
            <td>
              <select value={district} onChange={(e) => setDistrict(e.target.value)}>
                <option value="">--Select--</option>
                {districts.map((d, i) => (
                  <option key={i} value={d.dist_name_en}>
                    {d.dist_name_en}
                  </option>
                ))}
              </select>
            </td>
          </tr>
          <tr>
            <td colSpan="6">
              <button className="button button2" onClick={handleSubmit} disabled={loading}>
                Submit
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      {loading && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <CircularProgress />
        </div>
      )}

      {exists !== null && !loading && (
        <div style={{ marginTop: "20px" }}>
          {exists ? (
            <>
              <p>
                EKYC Failed Data In <b>{district}</b> | Month: {month} | Year: {year}
              </p>
              <p
                style={{ color: "blue", textDecoration: 'underline', cursor: "pointer", fontWeight: "bold" }}
                onClick={handleDownload}
              >
                Click here to download EKYC Failed Report for {district} in {month}/{year}
              </p>
            </>
          ) : (
            <p style={{ color: "red" }}>No Data Found</p>
          )}
        </div>
      )}
    </div>
  );
}

export default EKYC_Failed_Report;
